<template>

  <div class="">
    <m-login-1/>
  </div>
</template>

<script>

export default {
  name: 'HomeView',
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>
</style>